export const renderImage = (option, play, pause) => {
    const dom = document.createElement("img");
    dom.src = option.adLink;
    dom.onload = () => {
        play();
    };
    dom.onerror = (error) => {
        pause();
        throw error;
    };
    console.log(dom, "走这里");
    return dom;
};
//# sourceMappingURL=image.js.map